const state = {
  routeLoading: false,
  pageLoading: false,
};

const mutations = {
  set(state, { type, value }) {
    state[type] = value;
  },
};

const actions = {
  setRouteLoading({ commit }, val: boolean) {
    commit('set', { type: 'routeLoading', value: val });
  },
  setPageLoading({ commit }, val: boolean) {
    commit('set', { type: 'pageLoading', value: val });
  },
};

const getters = {
  routeLoading: (state) => state.routeLoading,
  pageLoading: (state) => state.pageLoading,
};

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
};
